export const BLACK_FRIDAY_NEWBUILDING_LISTING_PARAMS = 'is_black_friday=1';
